import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addSeat, getSingleSeat, updateSeat } from '../../../actions/homeAction'

const SeatsAdd = () => {
  const [seat, setSeat] = useState({
    seat:'',
    seatAr:'',
    priority: null,
    active: true
  })
  const [dataEdit, setDataEdit] = useState(false)

const {stUUID} = useParams()

const dispatch = useDispatch()

const location = window.location.href.split('/')[6]

useEffect(() => {
  if(location === 'Update'){
    dispatch(getSingleSeat(stUUID))
    setDataEdit(true)
  } else {
    setDataEdit(false)
  }
},[])

const singleSeat = useSelector(state => state.home.singleSeat)?.response
const data = singleSeat

useEffect(() => {
  setSeat({
    seat: data?.seat,
    seatAr: data?.seatAr,
    priority: data?.priority,
    active: data?.active === 0 ? 'false' : 'true'
  })
},[data?.seat])

console.log("seat", stUUID);
  const onChangeHandle = (e) => {
    const {name, value} = e.target
    setSeat({...seat, [name]:value})
  }
  
  
  const onSave = () => {
    if(dataEdit){
      const payload = {
        seat:seat.seat,
        seatAr:seat.seatAr,
        priority:seat.priority,
        active: seat.active,
        seatId: data.seatId
        }
        dispatch(updateSeat(payload))
      } else {
        dispatch(addSeat(seat))
    }
  }
  return (
    <div className='main-body'>
    <div className='page-wrapper'>
      <div className='page-header'>
        <div className='row align-items-end'>
          <div className='col-lg-8'>
            <div className='page-header-title'>
              <div className='d-inline'>
                <h4>
                  { dataEdit ? `Edit : ${seat?.seat}` : "Add Seat" } 
                </h4>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='page-header-breadcrumb'>
              <ul className='breadcrumb-title'>
                <li className='breadcrumb-item'>
                  <Link to='/'>
                    <i className='feather icon-home'></i>{' '}
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <Link to='/CarDetail/Seats'>Seat</Link>
                </li>
                <li className='breadcrumb-item active'>
                { dataEdit ? `Edit Seat` : "Add Seat" } 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='page-body'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='card card-border-default'>
              <div className='card-block'>
                
                <div className='tab-content tabs'>
                  <div
                    className='tab-pane  active'
                    id={'car_user_'}
                    role='tabpanel'
                    aria-labelledby=''>
                      <div className=''>
        	<div className='col-md-6'>
							
						</div>

        {/* sdjkfj */}
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Seat Name</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='seat'
										value={seat.seat}
										placeholder='Seat Name'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Seat Name Ar</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='seatAr'
										value={seat.seatAr}
										placeholder='Seat Name Ar'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>

              <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={seat.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
						
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										onChange={onChangeHandle}
										value={seat?.status}
                    >
										<option value={true} name='active'>
											Active
										</option>
										<option value={false} name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='row float-right p-3'>
							
							<button
								onClick={onSave}
								className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> { dataEdit ? 'Update' : 'Save'}
							</button>
							<Link to={'/CarDetail/Seats'} className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default SeatsAdd